"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65250],{

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ })

}]);